"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BGColor = void 0;
var BGColor;
(function (BGColor) {
    BGColor["primary"] = "bg-primary";
    BGColor["secondary"] = "bg-secondary";
    BGColor["success"] = "bg-success";
    BGColor["danger"] = "bg-danger";
    BGColor["warning"] = "bg-warning";
    BGColor["info"] = "bg-info";
    BGColor["purple"] = "bg-purple";
    BGColor["publication"] = "bg-publication";
    BGColor["dark"] = "bg-dark";
    BGColor["pale"] = "bg-pale";
    BGColor["light"] = "bg-light";
    BGColor["ivory"] = "bg-ivory";
    BGColor["white"] = "bg-white";
    BGColor["transparent"] = "bg-transparent";
})(BGColor || (exports.BGColor = BGColor = {}));
